import { NominationFormUrlContext } from "context/nominationFormUrlContext";

import { CurrentUserContext } from "context/currentUserContext";

import { RoleContext } from "context/roleContext";
import { useContext, useEffect, useState } from "react";

export function useNominationFormUrl() {
    const [nominationFormUrl, setNominationFormUrl] = useState<string>("");

    const nominationFormUrlContext = useContext(NominationFormUrlContext);
    const roleContext = useContext(RoleContext);
    const currentUserContext = useContext(CurrentUserContext);
    // Removed obsolete CouncilTokenContext usage

    useEffect(() => {
        if (!roleContext.roles || !currentUserContext.currentUser) return;

        if (
            roleContext.roles.isSysAdmin ||
            roleContext.roles.isCouncilUser
        ) {
            // Removed obsolete CouncilTokenContext fetch
        }
    }, [roleContext.roles, currentUserContext.currentUser]);

    useEffect(() => {
        setNominationFormUrl(nominationFormUrlContext?.formUrl);
    }, [nominationFormUrlContext.formUrl]);

    return nominationFormUrl;
}
